'use strict';

//var angular = require('angular');
var ParseCookieToHeaderFactory = function ParseCookieToHeaderFactory() {
  return {
    request: function request(config) {
      if (sessionStorage.getItem('carrierCode')) {
        config.headers.carrierCode = sessionStorage.getItem('carrierCode');
      }
      return config;
    }
  };
};
ParseCookieToHeaderFactory.$inject = [];
module.exports = ParseCookieToHeaderFactory;